export const filterEntries = <T extends Record<string, any>>(obj: T, filter: ([key, value]: [keyof T, T[keyof T]]) => boolean) =>
  Object.fromEntries(Object.entries(obj).filter(filter)) as Partial<T>;
